<div class="w-100 landing">
  <div class="container-landing">
    <img
      style="width: 100%"
      [src]="
        isMobile
          ? 'assets/images/landing/background-mobile.svg'
          : 'assets/images/landing/background.svg'
      "
    />
    <div class="centered">
      <div class="title">{{ "stage" | translate }}</div>
      <div class="intro">
        {{ "stage-intro" | translate }}
      </div>
    </div>
  </div>
  <div>
    <div class="meetings-section">
      <div id="current-meetings" class="section-title">
        {{ "current-meetings" | translate }}
      </div>
      <div class="row">
        <div
          *ngFor="let card of cards"
          class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
        >
          <app-meeting-card
            [isMobile]="isMobile"
            [card]="card"
          ></app-meeting-card>
        </div>
      </div>
    </div>
    <div id="contact-us" class="contact-us-section">
      <app-contact-us></app-contact-us>
    </div>
  </div>
  <app-footer></app-footer>
</div>
